import { fetchEventSourceApi } from '../../../lib/api';

export const sendMessageToStream = async ({
  conversationId,
  message,
  updateConversation,
  assistantType,
}) => {
  return fetchEventSourceApi('/api/ai/messages', {
    method: 'POST',
    headers: {
      Accept: 'text/event-stream',
    },
    body: JSON.stringify({
      message,
      assistant_type: assistantType,
      conversation_id: conversationId,
    }),
    openWhenHidden: true,
    async onopen(response) {
      if (
        response.status >= 400 &&
        response.status < 500 &&
        response.status !== 429
      ) {
        throw new Error();
      }
    },
    onmessage(msg) {
      const data = JSON.parse(msg.data);

      if (data.message) {
        updateConversation(data.message, data.conversation_id);
      }
    },
  });
};
